import { useState } from 'react';
import { ChevronDown, Phone } from 'lucide-react';
import { SW_PHONE_DISPLAY, SW_PHONE_RAW } from '../config';
import { useAirlineLanding } from '../AirlineContext';

export default function SwFaq() {
  const { faqIntro, faqs } = useAirlineLanding();
  const [openIndex, setOpenIndex] = useState(-1);

  return (
    <section className="swp-faq" id="swp-faq">
      <div className="swp-faq__media">
        <img
          src="/images/mountain-lake.jpg"
          alt="Travellers looking out over a mountain lake"
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className="swp-shell swp-faq__inner">
        <div className="swp-faq__card">
          <h2>Questions travellers ask most</h2>
          <p>{faqIntro}</p>

          <div className="swp-faq__list">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div className="swp-faq__item" key={faq.q}>
                  <button
                    type="button"
                    className="swp-faq__q"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  >
                    {faq.q}
                    <ChevronDown size={18} aria-hidden />
                  </button>
                  {isOpen ? <p className="swp-faq__a">{faq.a}</p> : null}
                </div>
              );
            })}
          </div>

          <div className="swp-faq__foot">
            <Phone size={15} aria-hidden />
            Need another answer?
            <a href={`tel:${SW_PHONE_RAW}`}>
              <strong>{SW_PHONE_DISPLAY}</strong>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
